import { render, staticRenderFns } from "./SmsCampaignRootView.vue?vue&type=template&id=6161feb9"
import script from "./SmsCampaignRootView.vue?vue&type=script&lang=js"
export * from "./SmsCampaignRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports